import { Divider, Grid, Typography } from '@mui/material'
import React from 'react'

export const PortalTabHeader: React.FC<{
  header: React.ReactNode | string
  description: React.ReactNode | string
  actionButton?: React.ReactNode
}> = ({ header, actionButton, description }) => {
  return (
    <>
      <Typography variant='h1'>
        {header}
      </Typography>
      {(header || actionButton) &&
        <Grid container sx={{ mb: '4px' }} justifyContent='space-between' wrap='nowrap'>
          <Grid item xs={8}>
            <Typography>
              {description}
            </Typography>
          </Grid>

          <Grid item xs={4} container justifyContent='flex-end'>
            <Grid item>
              {actionButton}
            </Grid>
          </Grid>
        </Grid>}
      <Divider sx={{ mb: '12px' }} />
    </>
  )
}
